export default {
    TOP: 3,
    EXTENDED: 10,
};



// WEBPACK FOOTER //
// ./src/app/constants/previous-search-count.js